import { TReportFold } from '../../../../types/partner-page-types';
import { If } from '../../../Atoms/Conditionals';
import { Heading, HeadingType } from '../../../Typography';

interface IGetReportSection {
  reportFold: TReportFold;
}

export const GetReportSection: React.FC<IGetReportSection> = ({
  reportFold,
}) => {
  if (!reportFold.active) return <></>;
  return (
    <div className="wg-container py-28 sm:py-14">
      <Heading
        content={reportFold.title}
        variant={HeadingType.h2}
        className="text-s-48 mb-6 sm:text-s-32"
      />
      <p
        className="font-medium text-font-200 sm:text-s-14"
        dangerouslySetInnerHTML={{ __html: reportFold.description }}
      ></p>
      <div className="flex pt-12 sm:flex-col sm:pt-5">
        {reportFold.steps.map((step, idx) => {
          return (
            <div className="w-1/4 pr-4 sm:w-full sm:pt-6" key={step.title}>
              <div className="flex items-center justify-between">
                <div className="text-[#4593FC] text-base font-bold py-2.5 flex items-center justify-center h-10 border-sm rounded-[40px] w-28 border-[#8EBEFD] sm:text-s-14 sm:h-8 sm:rounded-[32px]">{`STEP ${
                  idx + 1
                }`}</div>
                <If condition={reportFold.steps.length !== idx + 1}>
                  <hr className="border-[#8EBEFD] border-0 border-t-sm h-[1px] w-[calc(100%-112px)] ml-2 sm:hidden" />
                </If>
              </div>
              <div className="flex items-center pt-8 sm:pt-5">
                <img className="w-10 h-10" src={step.icon} alt="icon" />
                <p className="pl-3 text-s-20 text-grey-950 font-bold text-opacity-70">
                  {step.title}
                </p>
              </div>
              <p
                className="reportRichText pt-4 text-base text-grey-950 text-opacity-70"
                dangerouslySetInnerHTML={{
                  __html: step.richText,
                }}
              ></p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
